<template>
  <div class="diy-cert-landscape">
    <div class="diy-cert-page" @click="clearActive">
      <!-- 顶部导航栏 -->
      <div class="diy-header">
        <div class="header-back" @click="$router.back()">
          <van-icon name="arrow-left" />
        </div>
        <div class="header-title">
          <div class="block-title">证书预览</div>
          <div class="block-title">DIY元素</div>
        </div>
        <div class="header-placeholder"></div>
      </div>

      <!-- 主体：横向左右布局 -->
      <div class="diy-container">
        <!-- 左侧：证书预览 -->
        <div class="cert-preview">
          <div class="preview-wrap" ref="previewWrap">
            <div class="preview-box" ref="previewBox" id="diyCertBox">
              <img
                ref="certBg"
                src="../../assets/images/diy.jpg"
                class="cert-bg"
                @load="onBgLoaded"
                crossorigin="anonymous"
              />
              <div
                class="diy-area"
                ref="diyArea"
                @click.stop
                :style="diyAreaStyle"
              >
                <div
                  v-for="item in elements"
                  :key="item.id"
                  class="draggable-item"
                  :class="{ active: item.id === activeId }"
                  :style="getItemStyle(item)"
                  @mousedown.stop="selectItem(item.id, $event)"
                  @touchstart.stop="selectItem(item.id, $event)"
                  @click.stop
                >
                  <div
                    class="drag-body"
                    :class="{ cropping: hasCrop(item) && !item.cropping }"
                    @mousedown.stop="startDrag($event, item)"
                    @touchstart.stop="startDrag($event, item)"
                  >
                    <img
                      v-if="item.type === 'image'"
                      :src="item.src"
                      crossorigin="anonymous"
                      class="item-img"
                      :class="{ cropping: hasCrop(item) && !item.cropping }"
                      :style="getImageDisplayStyle(item)"
                      draggable="false"
                    />
                    <!-- 裁剪模式：完整图 + 矩形裁剪框 + 蒙版 -->
                    <template v-if="item.type === 'image' && item.cropping">
                      <div class="crop-shade" :style="getShadeStyle(item, 'top')"></div>
                      <div class="crop-shade" :style="getShadeStyle(item, 'left')"></div>
                      <div class="crop-shade" :style="getShadeStyle(item, 'right')"></div>
                      <div class="crop-shade" :style="getShadeStyle(item, 'bottom')"></div>
                      <div class="crop-box" :style="getCropBoxStyle(item)">
                        <div
                          class="crop-handle c-tl"
                          @mousedown.stop="startCropBox($event, item, 'tl')"
                          @touchstart.stop="startCropBox($event, item, 'tl')"
                        ></div>
                        <div
                          class="crop-handle c-tr"
                          @mousedown.stop="startCropBox($event, item, 'tr')"
                          @touchstart.stop="startCropBox($event, item, 'tr')"
                        ></div>
                        <div
                          class="crop-handle c-bl"
                          @mousedown.stop="startCropBox($event, item, 'bl')"
                          @touchstart.stop="startCropBox($event, item, 'bl')"
                        ></div>
                        <div
                          class="crop-handle c-br"
                          @mousedown.stop="startCropBox($event, item, 'br')"
                          @touchstart.stop="startCropBox($event, item, 'br')"
                        ></div>
                      </div>
                    </template>
                    <div
                      v-else-if="item.type === 'text'"
                      class="item-text"
                      :style="{ fontSize: item.fontSize + 'px' }"
                    >
                      {{ item.content }}
                    </div>
                  </div>

                  <template v-if="item.id === activeId">
                    <div
                      v-if=" !item.cropping"
                      class="rotate-handle"
                      title="按住围绕中心旋转"
                      @mousedown.stop="startRotate($event, item)"
                      @touchstart.stop="startRotate($event, item)"
                    ></div>
                    <template v-if="!item.cropping">
                      <div
                        class="resize-handle tl"
                        @mousedown.stop="startResize($event, item, 'tl')"
                        @touchstart.stop="startResize($event, item, 'tl')"
                      ></div>
                      <div
                        class="resize-handle tr"
                        @mousedown.stop="startResize($event, item, 'tr')"
                        @touchstart.stop="startResize($event, item, 'tr')"
                      ></div>
                      <div
                        class="resize-handle bl"
                        @mousedown.stop="startResize($event, item, 'bl')"
                        @touchstart.stop="startResize($event, item, 'bl')"
                      ></div>
                      <div
                        class="resize-handle br"
                        @mousedown.stop="startResize($event, item, 'br')"
                        @touchstart.stop="startResize($event, item, 'br')"
                      ></div>
                    </template>
                    <div
                      v-if="item.type === 'image'"
                      class="image-ops"
                      @click.stop
                    >
                      <button
                        v-if="!item.cropping"
                        class="op-btn crop-btn"
                        title="进入裁剪模式"
                        @click.stop="enterCropMode(item)"
                      >
                        裁剪
                      </button>
                      <button
                        v-else
                        class="op-btn done-btn"
                        title="完成裁剪"
                        @click.stop="exitCropMode(item)"
                      >
                        完成
                      </button>
                    </div>
                    <div class="delete-btn" @click.stop="deleteItem(item.id)">
                      ×
                    </div>
                    <div
                      v-if="item.type === 'text'"
                      class="font-size-controls"
                      @click.stop
                    >
                      <button @click.stop="changeFontSize(item, -2)">A-</button>
                      <span>{{ item.fontSize }}px</span>
                      <button @click.stop="changeFontSize(item, 2)">A+</button>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧：DIY 操作面板 -->
        <div class="diy-panel">
          <p class="panel-desc">
            您可使用证书DIY自定义生成电子证书，您可将作品图片、作品名称、作品描述分别放置在【获奖作品展示区】并调整位置、大小，在确认最终效果后点击保存即可生成独一无二的电子证书。
          </p>

          <div class="btn-list">
            <div class="btn-row">
              <span
                class="status-tag"
                :class="{ added: hasElementByType('image') }"
                >{{ hasElementByType("image") ? "已添加" : "未添加" }}</span
              >
              <button class="ctrl-btn" @click.stop="addImageElement">
                作品图片
              </button>
            </div>
            <div class="btn-row">
              <span
                class="status-tag"
                :class="{ added: hasElementByType('title') }"
                >{{ hasElementByType("title") ? "已添加" : "未添加" }}</span
              >
              <button class="ctrl-btn" @click.stop="addTextElement('title')">
                作品名称
              </button>
            </div>
            <div class="btn-row">
              <span
                class="status-tag"
                :class="{ added: hasElementByType('desc') }"
                >{{ hasElementByType("desc") ? "已添加" : "未添加" }}</span
              >
              <button class="ctrl-btn" @click.stop="addTextElement('desc')">
                作品描述
              </button>
            </div>
            <div class="btn-row full">
              <button class="ctrl-btn ctrl-btn-full" @click.stop="useTemplate">
                预设模板
              </button>
            </div>
          </div>

          <div class="bottom-btns">
            <button class="reset-btn" @click.stop="resetAll">重置</button>
            <button class="save-btn" @click.stop="saveCert">
              生成并保存我的证书
            </button>
          </div>
        </div>
      </div>

      <!-- 生成结果弹窗：不自动下载，由用户长按图片手动保存/分享 -->
      <van-popup
        v-model="showSavePopup"
        class="diy-save-popup"
        :style="{ height: '100%', width: '100%' }"
      >
        <div class="diy-save-content">
          <div class="diy-save-close" @click="showSavePopup = false">
            <van-icon name="close" />
          </div>
          <p class="diy-save-tip">长按图片即可保存或分享</p>
          <img
            v-if="certImgUrl"
            :src="certImgUrl"
            alt="我的DIY证书"
            class="diy-save-img"
          />
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import diyBg from "../../assets/images/diy.jpg";

export default {
  data() {
    return {
      id: "",
      imgurl: "",
      title: "",
      desc: "",
      author: "",
      elements: [],
      activeId: null,
      bgLoaded: false,
      bgImgSrc: "",
      // 证书生成结果弹窗
      showSavePopup: false,
      certImgUrl: "",
      // diyArea 比例（基于背景图原始尺寸）
      // 可编辑区域位于证书底图的右侧（获奖作品展示区）
      diyAreaRatio: { left: 0.04, top: 0.25, right: 0.5, bottom: 0.08 }
    };
  },
  computed: {
    diyAreaStyle() {
      return {
        left: this.diyAreaRatio.left * 100 + "%",
        top: this.diyAreaRatio.top * 100 + "%",
        right: this.diyAreaRatio.right * 100 + "%",
        bottom: this.diyAreaRatio.bottom * 100 + "%"
      };
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    this.imgurl = decodeURIComponent(this.$route.query.imgurl || "");
    this.title = decodeURIComponent(this.$route.query.title || "");
    this.desc = decodeURIComponent(this.$route.query.desc || "");
    this.author = decodeURIComponent(this.$route.query.author || "");
    let certificate = decodeURIComponent(this.$route.query.certificate || "");
    this.bgImgSrc = diyBg; // certificate
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    onBgLoaded() {
      this.bgLoaded = true;
        this.syncPreviewBoxSize();
    },
    /**
     * 让 preview-box（diyCertBox）在视觉上铺满 preview-wrap 的视觉高度，
     * 宽度按 cert-bg 原始宽高比计算，使 preview-box 视觉尺寸 = cert-bg 显示尺寸。
     * 这样 diy-area（absolute inset:0）就能正好覆盖 cert-bg。
     *
     * 关键：页面通过 transform: rotate(90deg) 旋转，getBoundingClientRect() 返回
     * 旋转后的视觉尺寸（视觉宽 × 视觉高），而 style.width/height 是在 landscape
     * 坐标系（未旋转）中设置的，两者宽高方向相反：
     *   style.width  → 旋转后对应视觉高度
     *   style.height → 旋转后对应视觉宽度
     */
    syncPreviewBoxSize() {
      this.$nextTick(() => {
        const box = this.$refs.previewBox;
        const wrap = this.$refs.previewWrap;
        const img = this.$refs.certBg;
        if (!box || !wrap || !img) return;
        const wrapRect = wrap.getBoundingClientRect();
        const pad = 6;
        // 视觉可用尺寸（旋转后）
        const visualW = Math.floor(wrapRect.width - pad * 2);   // 视觉宽度
        const visualH = Math.floor(wrapRect.height - pad * 2);  // 视觉高度
        if (visualW <= 0 || visualH <= 0) return;
        // 证书底图视觉宽高比 593:839（视觉宽 : 视觉高）
        const RATIO_W = 593;
        const RATIO_H = 839;
        // landscape 坐标系：style.width → 视觉高度，style.height → 视觉宽度
        // 视觉宽高比 = style.height / style.width = 593/839 
        // 先按视觉高度铺满，计算对应的视觉宽度
        let styleW = visualH;                          // style.width（→视觉高度，铺满）
        let styleH = styleW * RATIO_W / RATIO_H;       // style.height（→视觉宽度）
        // 若算出的视觉宽度超出可用视觉宽度，则以视觉宽度为基准反推视觉高度
        if (styleH > visualW) {
          styleH = visualW;
          styleW = styleH * RATIO_H / RATIO_W;
        }
        // 以 style.height 为基准取整，style.width 按比例精确推导，保持 839:593 视觉宽高比
        const finalH = Math.floor(styleH);
        const finalW = Math.round(finalH * RATIO_H / RATIO_W);
        console.log('finalH:finalW', finalH, finalW);
        box.style.width = finalW + "px";
        box.style.height = finalH + "px";
      });
    },
    handleResize() {
      this.syncPreviewBoxSize();
    },
    getItemStyle(item) {
      return {
        left: item.x + "px",
        top: item.y + "px",
        width: item.width + "px",
        height: item.height + "px",
        // 旋转作用于整个 draggable-item 元素，围绕元素框中心
        transform: "rotate(" + (item.rotate || 0) + "deg)",
        transformOrigin: "center"
      };
    },
    selectItem(id, e) {
      this.activeId = id;
      // 不调用 e.preventDefault()，否则会阻止移动端后续 click 事件触发，
      // 导致 deleteItem / changeFontSize 等按钮点击无效。
      // 文本选中问题通过 CSS user-select: none 处理。
    },
    clearActive() {
      this.activeId = null;
    },
    hasElementByType(type) {
      return this.elements.some(el => el.elementType === type);
    },
    genId() {
      return Date.now() + Math.floor(Math.random() * 1000);
    },
    getAreaSize() {
      const area = this.$refs.diyArea;
      if (!area) return { w: 300, h: 200 };
      const rect = area.getBoundingClientRect();
      return { w: rect.width, h: rect.height };
    },
    /**
     * 将屏幕坐标（clientX/clientY）转换为旋转后容器内的本地坐标。
     *
     * 页面通过 transform: rotate(90deg) 绕左上角旋转，
     * 旋转后的坐标系映射关系（数学推导）：
     *   假设旋转后容器左上角在屏幕坐标 (ox, oy)
     *   对于容器内某点 (lx, ly)（未旋转时的坐标），
     *   旋转 90° 后在屏幕上的坐标 (cx, cy) 满足：
     *     cx = oy + ly          （屏幕 X = 容器原点 Y + 本地 Y）
     *     cy = oy + (containerWidth - lx)   （屏幕 Y = 容器原点 Y + 容器宽 - 本地 X）
     *   反推：
     *     lx = oy + containerWidth - cy
     *     ly = cx - ox
     *
     * 使用 getBoundingClientRect 获取旋转后的实际矩形（width/height 已交换），
     * 直接计算相对偏移，避免手动算旋转矩阵。
     */
    screenToLocal(clientX, clientY) {
      const area = this.$refs.diyArea;
      if (!area) return { x: 0, y: 0 };
      const rect = area.getBoundingClientRect();
      // 页面绕原点顺时针旋转 90° 后：
      //   屏幕 X = rect.right - 本地 Y
      //   屏幕 Y = rect.top + 本地 X
      // 反推：
      //   本地 X = clientY - rect.top
      //   本地 Y = rect.right - clientX
      const localX = clientY - rect.top;
      const localY = rect.right - clientX;
      return { x: localX, y: localY };
    },
    addImageElement() {
      if (!this.imgurl) {
        this.$toast && this.$toast.fail
          ? this.$toast.fail({
              message: "请先上传作品图片",
              className: "diy-toast-landscape"
            })
          : alert("请先上传作品图片");
        return;
      }
      const exist = this.elements.find(el => el.elementType === "image");
      if (exist) {
        this.activeId = exist.id;
        return;
      }
      const { w, h } = this.getAreaSize();
      const id = this.genId();
      this.elements.push({
        id,
        type: "image",
        elementType: "image",
        src: this.imgurl,
        x: Math.max(0, w / 2 - 80),
        y: Math.max(0, h / 2 - 60),
        width: 160,
        height: 120,
        rotate: 0,
        cropping: false,
        cropRect: null,
        natW: 0,
        natH: 0
      });
      this.activeId = id;
    },
    addTextElement(elementType) {
      const exist = this.elements.find(el => el.elementType === elementType);
      if (exist) {
        this.activeId = exist.id;
        return;
      }
      const { w, h } = this.getAreaSize();
      const id = this.genId();
      let content = "";
      let fontSize = 18;
      if (elementType === "title") {
        content = this.title || "作品名称";
        fontSize = 22;
      } else if (elementType === "desc") {
        content = this.desc || "作品描述";
        fontSize = 14;
      }
      this.elements.push({
        id,
        type: "text",
        elementType,
        content,
        fontSize,
        x: Math.max(0, w / 2 - 110),
        y: elementType === "title" ? Math.max(0, h * 0.1) : Math.max(0, h * 0.5),
        width: 100,
        height: elementType === "title" ? 40 : 80
      });
      this.activeId = id;
    },
    useTemplate() {
      this.elements = [];
      const { w, h } = this.getAreaSize();
      if (this.imgurl) {
        this.elements.push({
          id: this.genId(),
          type: "image",
          elementType: "image",
          src: this.imgurl,
          x: 20,
          y: 30,
          width: Math.min(w * 0.45, 180),
          height: Math.min(h * 0.5, 130),
          rotate: 0,
          cropping: false,
          cropRect: null,
          natW: 0,
          natH: 0
        });
      }
      if (this.title) {
        this.elements.push({
          id: this.genId(),
          type: "text",
          elementType: "title",
          content: this.title,
          fontSize: 22,
          x: 80,
          y: Math.min(h * 0.1, h*0.5),
          width: w *0.5,
          height: 36
        });
      }
      if (this.desc) {
        this.elements.push({
          id: this.genId(),
          type: "text",
          elementType: "desc",
          content: this.desc,
          fontSize: 13,
          x: 80,
          y: Math.min(h * 0.2, h*0.7),
          width: w *0.5,
          height: 64
        });
      }
      this.activeId = null;
    },
    resetAll() {
      this.elements = [];
      this.activeId = null;
    },
    deleteItem(id) {
      this.elements = this.elements.filter(el => el.id !== id);
      this.activeId = null;
    },
    changeFontSize(item, delta) {
      const next = item.fontSize + delta;
      if (next < 10) return;
      if (next > 72) return;
      item.fontSize = next;
      this.$forceUpdate();
    },
    /**
     * 拖动图片外侧的旋转手柄，围绕图片中心自由旋转任意角度。
     * 借助 screenToLocal 换算到本地坐标系，计算指针相对图片中心的角度增量。
     */
    startRotate(e, item) {
      e.preventDefault();
      e.stopPropagation();
      this.activeId = item.id;
      const point = this.getPoint(e);
      const startLocal = this.screenToLocal(point.x, point.y);
      // 图片中心（本地坐标）
      const cx = item.x + item.width / 2;
      const cy = item.y + item.height / 2;
      const startAngle =
        (Math.atan2(startLocal.y - cy, startLocal.x - cx) * 180) / Math.PI;
      const origRotate = item.rotate || 0;
      const self = this;

      const move = ev => {
        ev.preventDefault && ev.preventDefault();
        const p = self.getPoint(ev);
        const curLocal = self.screenToLocal(p.x, p.y);
        const curAngle =
          (Math.atan2(curLocal.y - cy, curLocal.x - cx) * 180) / Math.PI;
        let angle = origRotate + (curAngle - startAngle);
        // 归一到 -180 ~ 180，便于保存与后续计算
        angle = ((angle % 360) + 360) % 360;
        if (angle > 180) angle -= 360;
        item.rotate = Math.round(angle);
        self.$forceUpdate();
      };
      const end = () => {
        document.removeEventListener("mousemove", move);
        document.removeEventListener("mouseup", end);
        document.removeEventListener("touchmove", move);
        document.removeEventListener("touchend", end);
      };
      document.addEventListener("mousemove", move);
      document.addEventListener("mouseup", end);
      document.addEventListener("touchmove", move, { passive: false });
      document.addEventListener("touchend", end);
    },
    /**
     * 进入裁剪模式：图片元素上直接显示裁剪框（复用四角），
     * 拖动四角可改变图片在框内的可见范围，实现裁剪。
     */
    enterCropMode(item) {
      item.cropping = true;
      // 确保尺寸就绪后初始化裁剪选区为整图
      this.initCropRect(item);
      this.activeId = item.id;
      this.ensureImageSize(item);
    },
    /**
     * 若还没有裁剪选区，则初始化为整图（需在尺寸就绪后）。
     */
    initCropRect(item) {
      if (!item.cropRect && item.natW && item.natH) {
        item.cropRect = {
          left: 0,
          top: 0,
          right: item.natW,
          bottom: item.natH
        };
      }
    },
    /**
     * 确保图片原始尺寸已加载（用于坐标换算）。加载成功后若还没有裁剪选区，则初始化为整图。
     */
    ensureImageSize(item) {
      if (item.natW && item.natH) {
        this.initCropRect(item);
        return;
      }
      this.loadImage(item.src).then(img => {
        if (img) {
          item.natW = img.naturalWidth;
          item.natH = img.naturalHeight;
          this.initCropRect(item);
          this.$forceUpdate();
        }
      });
    },
    exitCropMode(item) {
      item.cropping = false;
      this.$forceUpdate();
    },
    /**
     * 图片在元素框内 contain 显示的区域（含偏移和缩放）。
     */
    getContainRect(item) {
      const W = item.width;
      const H = item.height;
      const iw = item.natW;
      const ih = item.natH;
      if (!iw || !ih) return { s: 1, ox: 0, oy: 0, dw: W, dh: H };
      const s = Math.min(W / iw, H / ih);
      const dw = iw * s;
      const dh = ih * s;
      return { s, ox: (W - dw) / 2, oy: (H - dh) / 2, dw, dh };
    },
    /**
     * 裁剪框在元素框内的位置（用于裁剪模式下显示矩形选区）。
     */
    getCropBoxStyle(item) {
      const r = item.cropRect || { left: 0, top: 0, right: 0, bottom: 0 };
      const cr = this.getContainRect(item);
      const left = cr.ox + r.left * cr.s;
      const top = cr.oy + r.top * cr.s;
      const right = cr.ox + r.right * cr.s;
      const bottom = cr.oy + r.bottom * cr.s;
      return {
        left: left + "px",
        top: top + "px",
        width: Math.max(0, right - left) + "px",
        height: Math.max(0, bottom - top) + "px"
      };
    },
    /**
     * 裁剪模式四块蒙版的位置（遮住选区外）。
     */
    getShadeStyle(item, side) {
      const r = item.cropRect || { left: 0, top: 0, right: 0, bottom: 0 };
      const cr = this.getContainRect(item);
      const left = cr.ox + r.left * cr.s;
      const top = cr.oy + r.top * cr.s;
      const right = cr.ox + r.right * cr.s;
      const bottom = cr.oy + r.bottom * cr.s;
      const common = {
        position: "absolute",
        background: "rgba(0,0,0,0.5)",
        zIndex: 2,
        pointerEvents: "none"
      };
      if (side === "top") {
        return Object.assign({}, common, {
          left: 0,
          right: 0,
          top: 0,
          height: top + "px"
        });
      }
      if (side === "left") {
        return Object.assign({}, common, {
          top: top + "px",
          bottom: 0,
          left: 0,
          width: left + "px"
        });
      }
      if (side === "right") {
        return Object.assign({}, common, {
          top: top + "px",
          bottom: 0,
          right: 0,
          width: Math.max(0, item.width - right) + "px"
        });
      }
      return Object.assign({}, common, {
        left: left + "px",
        right: 0,
        bottom: 0,
        height: Math.max(0, item.height - bottom) + "px"
      });
    },
    /**
     * 拖动裁剪框四角：每个角独立移动，形成任意偏移/大小的矩形选区。
     */
    startCropBox(e, item, corner) {
      e.preventDefault();
      e.stopPropagation();
      this.activeId = item.id;
      this.ensureImageSize(item);
      const rad = ((item.rotate || 0) * Math.PI) / 180;
      const cx = item.x + item.width / 2;
      const cy = item.y + item.height / 2;
      const r = item.cropRect || { left: 0, top: 0, right: 0, bottom: 0 };
      const orig = {
        left: r.left,
        top: r.top,
        right: r.right,
        bottom: r.bottom
      };
      const cr = this.getContainRect(item);
      const point = this.getPoint(e);
      const startLocal = this.screenToLocal(point.x, point.y);
      const startQ = this.unrotatePoint(startLocal, cx, cy, rad);
      const self = this;

      const move = ev => {
        ev.preventDefault && ev.preventDefault();
        const p = self.getPoint(ev);
        const curLocal = self.screenToLocal(p.x, p.y);
        const curQ = self.unrotatePoint(curLocal, cx, cy, rad);
        // 元素框内的位移增量 -> 换算为图片像素坐标增量
        const dx = (curQ.x - startQ.x) / cr.s;
        const dy = (curQ.y - startQ.y) / cr.s;
        const min = 10; // 选区最小像素
        if (corner.indexOf("l") > -1) {
          r.left = self.clamp(orig.left + dx, 0, orig.right - min);
        }
        if (corner.indexOf("r") > -1) {
          r.right = self.clamp(orig.right + dx, orig.left + min, item.natW);
        }
        if (corner.indexOf("t") > -1) {
          r.top = self.clamp(orig.top + dy, 0, orig.bottom - min);
        }
        if (corner.indexOf("b") > -1) {
          r.bottom = self.clamp(orig.bottom + dy, orig.top + min, item.natH);
        }
        self.$forceUpdate();
      };
      const end = () => {
        document.removeEventListener("mousemove", move);
        document.removeEventListener("mouseup", end);
        document.removeEventListener("touchmove", move);
        document.removeEventListener("touchend", end);
      };
      document.addEventListener("mousemove", move);
      document.addEventListener("mouseup", end);
      document.addEventListener("touchmove", move, { passive: false });
      document.addEventListener("touchend", end);
    },
    clamp(v, min, max) {
      return Math.max(min, Math.min(max, v));
    },
    /**
     * 判断图片是否有裁剪（裁剪选区小于整图）。
     */
    hasCrop(item) {
      const r = item.cropRect;
      if (!r) return false;
      return !(r.left === 0 && r.top === 0 && r.right === item.natW && r.bottom === item.natH);
    },
    /**
     * 图片显示样式：
     *  - 未裁剪：返回 null，走 CSS 默认 contain 显示（完整图片居中）。
     *  - 已裁剪：把裁剪选区放大填满元素框（cover 语义）。
     */
    getImageDisplayStyle(item) {
      if (item.cropping) return null; // 裁剪模式下显示完整图用于选取
      if (!this.hasCrop(item)) return null;
      const r = item.cropRect;
      const W = item.width;
      const H = item.height;
      const iw = item.natW;
      const ih = item.natH;
      if (!iw || !ih) return null;
      const selW = Math.max(1, r.right - r.left);
      const selH = Math.max(1, r.bottom - r.top);
      const S = Math.max(W / selW, H / selH);
      // 选区放大后居中，图片左上角据此定位
      const boxCropX = (W - selW * S) / 2;
      const boxCropY = (H - selH * S) / 2;
      const left = boxCropX - r.left * S;
      const top = boxCropY - r.top * S;
      return {
        width: iw * S + "px",
        height: ih * S + "px",
        left: left + "px",
        top: top + "px"
      };
    },
    getPoint(e) {
      if (e.touches && e.touches.length > 0) {
        return { x: e.touches[0].clientX, y: e.touches[0].clientY };
      }
      return { x: e.clientX, y: e.clientY };
    },
    startDrag(e, item) {
      e.preventDefault();
      if (item.cropping) return; // 裁剪模式下禁止拖动元素
      this.activeId = item.id;
      const area = this.$refs.diyArea;
      if (!area) return;
      const point = this.getPoint(e);
      // 记录起始点在本地坐标系下的位置
      const startLocal = this.screenToLocal(point.x, point.y);
      const origX = item.x;
      const origY = item.y;
      const self = this;

      const move = ev => {
        ev.preventDefault && ev.preventDefault();
        const p = self.getPoint(ev);
        const curLocal = self.screenToLocal(p.x, p.y);
        // 本地坐标增量直接对应 item.x/y 的增量
        let nx = origX + (curLocal.x - startLocal.x);
        let ny = origY + (curLocal.y - startLocal.y);
        // 限制在 diyArea 内
        const areaSize = self.getAreaSize();
        nx = Math.max(0, Math.min(nx, areaSize.w - item.width));
        ny = Math.max(0, Math.min(ny, areaSize.h - item.height));
        item.x = nx;
        item.y = ny;
        self.$forceUpdate();
      };
      const end = () => {
        document.removeEventListener("mousemove", move);
        document.removeEventListener("mouseup", end);
        document.removeEventListener("touchmove", move);
        document.removeEventListener("touchend", end);
      };
      document.addEventListener("mousemove", move);
      document.addEventListener("mouseup", end);
      document.addEventListener("touchmove", move, { passive: false });
      document.addEventListener("touchend", end);
    },
    /**
     * 将本地坐标绕指定中心逆旋转，得到元素未旋转坐标系下的坐标。
     * 元素使用 CSS transform: rotate(θ) 顺时针旋转，故此处用 -θ 逆变换。
     */
    unrotatePoint(p, cx, cy, rad) {
      const dx = p.x - cx;
      const dy = p.y - cy;
      const cos = Math.cos(rad);
      const sin = Math.sin(rad);
      return {
        x: dx * cos + dy * sin + cx,
        y: -dx * sin + dy * cos + cy
      };
    },
    startResize(e, item, direction) {
      e.preventDefault();
      e.stopPropagation();
      this.activeId = item.id;
      const rad = ((item.rotate || 0) * Math.PI) / 180;
      // 元素中心（本地坐标）
      const cx = item.x + item.width / 2;
      const cy = item.y + item.height / 2;
      const origW = item.width;
      const origH = item.height;
      const self = this;

      // 拖拽方向对应在未旋转坐标系中放大/缩小的轴向符号
      //   r / b：指针正向移动 -> 尺寸增大（+）
      //   l / t：指针正向移动 -> 尺寸减小（-）
      const signX = direction.indexOf("r") > -1 ? 1 : -1;
      const signY = direction.indexOf("b") > -1 ? 1 : -1;

      const move = ev => {
        ev.preventDefault && ev.preventDefault();
        const p = self.getPoint(ev);
        const curLocal = self.screenToLocal(p.x, p.y);
        const curQ = self.unrotatePoint(curLocal, cx, cy, rad);
        // 相对中心的未旋转坐标（元素自身坐标轴方向）
        const ox = curQ.x - cx;
        const oy = curQ.y - cy;
        // 新宽高：中心到指针在该轴上的投影（保证中心不动）
        let nw = Math.max(30, Math.abs(ox) * 2);
        let nh = Math.max(30, Math.abs(oy) * 2);
        // 该角只会影响对应的轴，另一轴保持原尺寸
        if (signX > 0 && ox < 0) nw = origW; // 拖 r 时若指针越过中心，保持原宽
        if (signX < 0 && ox > 0) nw = origW; // 拖 l 时若指针越过中心，保持原宽
        if (signY > 0 && oy < 0) nh = origH; // 拖 b 时若指针越过中心，保持原高
        if (signY < 0 && oy > 0) nh = origH; // 拖 t 时若指针越过中心，保持原高
        // 中心不动，据此推导左上角位置
        let nx = cx - nw / 2;
        let ny = cy - nh / 2;
        // 限制不超出 diyArea（以未旋转框近似）
        const areaSize = self.getAreaSize();
        nx = Math.max(0, Math.min(nx, areaSize.w - nw));
        ny = Math.max(0, Math.min(ny, areaSize.h - nh));
        item.x = nx;
        item.y = ny;
        item.width = nw;
        item.height = nh;
        self.$forceUpdate();
      };
      const end = () => {
        document.removeEventListener("mousemove", move);
        document.removeEventListener("mouseup", end);
        document.removeEventListener("touchmove", move);
        document.removeEventListener("touchend", end);
      };
      document.addEventListener("mousemove", move);
      document.addEventListener("mouseup", end);
      document.addEventListener("touchmove", move, { passive: false });
      document.addEventListener("touchend", end);
    },
    async saveCert() {
      if (this.elements.length === 0) {
        const tip = this.$toast && this.$toast.fail
          ? this.$toast
          : { fail: msg => alert(msg) };
        tip.fail({
          message: "请先放入作品图片、文字等元素后再生成",
          className: "diy-toast-landscape"
        });
        return;
      }
      this.activeId = null;
      // 保存前强制退出所有裁剪模式，避免裁剪框/蒙版渲染进证书
      this.elements.forEach(el => {
        if (el.cropping) el.cropping = false;
      });
      await new Promise(resolve => setTimeout(resolve, 100));
      const loading = this.$toast
        ? this.$toast.loading({
            message: "证书生成中...",
            forbidClick: true,
            duration: 0,
            className: "diy-toast-landscape"
          })
        : null;

      // ---- html2canvas 渲染 DOM + 旋转画布 ----
      // 之前用手动 Canvas 计算元素坐标，坐标系（旋转）复杂且反复出错，
      // 方向/位置难以保证。这里改为【以浏览器原生渲染为准】：
      //   1. 页面里的 previewBox 就是用户看到的预览效果（底图 + 元素，
      //      位置/方向由浏览器保证正确），整体只是被 rotate(90deg) 旋转；
      //   2. 用 html2canvas 渲染 previewBox，在 onclone 里只清除旋转
      //      transform、不修改任何尺寸/坐标，得到的画布元素位置与预览
      //      完全一致（方向绝对正确）；
      //   3. 再把横向画布顺时针旋转 90° 输出为竖向证书，与页面视觉一致。
      // 这样彻底不依赖手算坐标，方向/位置由 DOM 布局保证。
      try {
        const sourceBox = this.$refs.previewBox;
        if (!sourceBox) throw new Error("预览节点不存在");
        await new Promise(resolve => setTimeout(resolve, 50));
        await this.$nextTick();

        // 1) html2canvas 渲染 landscape（未旋转）内容，位置/方向与预览一致
        const landscapeCanvas = await html2canvas(sourceBox, {
          useCORS: true,
          allowTaint: true,
          scale: 3,
          backgroundColor: "#ffffff",
          logging: false,
          onclone: clonedDoc => {
            const clonedLandscape = clonedDoc.querySelector(
              ".diy-cert-landscape"
            );
            if (clonedLandscape) {
              // 只清旋转，不动任何尺寸/坐标
              clonedLandscape.style.transform = "none";
              clonedLandscape.style.transformOrigin = "0 0";
            }
          }
        });

        // 2) 旋转横向画布 → 竖向画布
        const landW = landscapeCanvas.width;
        const landH = landscapeCanvas.height;

        // 2a) 顺时针旋转 90° 写入临时画布
        const rotatedCanvas = document.createElement("canvas");
        rotatedCanvas.width = landH;
        rotatedCanvas.height = landW;
        const rctx = rotatedCanvas.getContext("2d");
        rctx.save();
        rctx.translate(rotatedCanvas.width, 0);
        rctx.rotate(Math.PI / 2); // 顺时针 90°（与页面 rotate(90deg) 一致）
        rctx.drawImage(landscapeCanvas, 0, 0);
        rctx.restore();
        // ============ 【调试】旋转后的画布 ============
        console.log("[saveCert] 旋转90°后 rotatedCanvas =",
          rotatedCanvas.width, "x", rotatedCanvas.height, "(竖向)");

        // 2b) 创建输出画布（竖向），把旋转结果写入（不再放大，保持 html2canvas 的 scale=2 清晰度）
        const canvas = document.createElement("canvas");
        canvas.width = rotatedCanvas.width;
        canvas.height = rotatedCanvas.height;
        const ctx = canvas.getContext("2d");
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(rotatedCanvas, 0, 0);

        const url = canvas.toDataURL("image/png");
        // ============ 【调试】最终输出 ============
        console.log("[saveCert] 最终输出 canvas =",
          canvas.width, "x", canvas.height,
          "| dataURL 前 40 字符 =", url.slice(0, 40));
        if (loading) loading.clear();
        // 不自动下载，将生成结果放入弹窗，由用户长按图片手动保存/分享
        this.certImgUrl = url;
        this.showSavePopup = true;
      } catch (err) {
        // ============ 【调试】异常信息 ============
        console.error("[saveCert] 生成证书异常：", err);
        if (loading) loading.clear();
        const tip = this.$toast && this.$toast.fail
          ? this.$toast
          : { fail: msg => alert(msg) };
        tip.fail({
          message: "证书生成失败：" + (err && err.message ? err.message : ""),
          className: "diy-toast-landscape"
        });
      }
    },
    /**
     * 加载一张图片。跨域图片开启 crossOrigin 以便 Canvas 可导出；
     * 若图片无法通过 CORS 加载（如 OSS 未配置跨域），返回 null，
     * 由调用方决定降级处理，保证本地与线上行为一致。
     * @returns {Promise<HTMLImageElement|null>}
     */
    loadImage(src) {
      return new Promise(resolve => {
        if (!src) return resolve(null);
        const img = new Image();
        img.crossOrigin = "anonymous";
        const done = () => resolve(img);
        const fail = () => resolve(null);
        img.onload = done;
        img.onerror = fail;
        img.src = src;
      });
    },
    /**
     * 生成一个灰色占位图片的 dataURI，用于跨域加载失败时兜底，
     * 保证 html2canvas 渲染不空白。
     */
    makePlaceholder() {
      const c = document.createElement("canvas");
      c.width = 80;
      c.height = 60;
      const ctx = c.getContext("2d");
      ctx.fillStyle = "#e0e0e0";
      ctx.fillRect(0, 0, 80, 60);
      ctx.strokeStyle = "#bbbbbb";
      ctx.lineWidth = 2;
      ctx.strokeRect(1, 1, 78, 58);
      return c.toDataURL("image/png");
    },
  }
};
</script>

<style lang="scss" scoped>
/* ============================================================
 * 移动端横屏页面实现方案：
 * 使用 CSS transform: rotate(90deg) 旋转整个页面容器
 * 配合 transform-origin 和 translate 定位
 * 交换宽高（width: 100vh; height: 100vw）填满竖屏手机的视口
 *
 * 原理：
 *   竖屏手机视口为 375×667
 *   容器原始尺寸 100vw × 100vh = 375 × 667
 *   旋转 90deg 后视觉宽度变为 667、高度变为 375
 *   但 transform-origin 默认在中心，旋转后位置会偏移
 *   设置 transform-origin: top left 后绕左上角旋转
 *   再用 translate(100vw, 0) 把容器推回视口内
 *   最终容器铺满整个手机屏幕，呈现横屏效果
 * ============================================================ */

.diy-cert-landscape {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vh;
  height: 100vw;
  /* 必须低于 Vant Toast 默认层级（2000），否则生成/成功/失败提示
     会被本容器遮挡导致无法显示 */
  z-index: 1999;
  background: #fff;
  overflow: hidden;
  /* 关键：绕左上角旋转 90 度 */
  transform-origin: 0 0;
  transform: rotate(90deg) translateY(-100vw);
  /* 等价写法：
     transform: rotate(90deg);
     transform-origin: top left;
     然后通过 translate 定位 */
}

.diy-cert-page {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
}

/* 顶部导航栏 */
.diy-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  padding: 0 12px;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;

  .header-back {
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .van-icon {
      font-size: 18px;
      color: #333;
    }
  }

  .header-title {
    flex: 1;
    display: flex;
    align-items: center;
    /* 左标题占左侧 70%，右标题占右侧 30%，与下方容器比例对齐 */
    justify-content: flex-start;

    .block-title {
      font-size: 14px;
      font-weight: 600;
      color: #222;
      margin: 0;
      white-space: nowrap;
    }

    /* 第一个标题（证书预览）占 70% */
    .block-title:first-child {
      flex: 0 0 70%;
      padding-left: 4px;
    }

    /* 第二个标题（DIY元素）占 30%，靠左对齐 */
    .block-title:last-child {
      flex: 0 0 30%;
      padding-left: 12px;
    }
  }

  .header-placeholder {
    width: 40px;
  }
}

/* 主体：横向左右布局 */
.diy-container {
  flex: 1;
  display: flex;
  flex-direction: row;
  gap: 12px;
  padding: 10px 12px;
  align-items: stretch;
  width: 100%;
  box-sizing: border-box;
  min-height: 0;
  overflow: hidden;
}

/* ===== 左侧：证书预览区（占 60%）===== */
.cert-preview {
  /* 占横屏长度的 60% */
  flex: 0 0 60%;
  min-width: 0;
  display: flex;
  flex-direction: column;

  .preview-wrap {
    flex: 1;
    width: 100%;
    background: #fafafa;
    border-radius: 6px;
    padding: 6px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 0;
    overflow: hidden;
    /* 确保 preview-box 不会撑满，让图片按比例缩放 */
    position: relative;
  }

  /* preview-box 尺寸由 JS 按图片实际渲染尺寸设置，确保 diy-area 精确覆盖 cert-bg */
  .preview-box {
    position: relative;
    max-width: 100%;
    max-height: 100%;
    line-height: 0;
    margin: auto;

    .cert-bg {
      /* preview-box 尺寸已按图片原始宽高比计算，直接填满即可，diy-area 正好覆盖 */
      display: block;
      width: 100%;
      height: 100%;
      object-fit: fill;
    }

    /* diy-area 完全覆盖 cert-bg */
    .diy-area {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow: hidden;
    }
  }
}

/* ===== 右侧：DIY 操作面板（占 40%）===== */
.diy-panel {
  /* 占横屏长度的 30%（减去 gap 后的剩余空间） */
  flex: 0 0 calc(40% - 12px);
  min-width: 0;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .panel-desc {
    font-size: 11px;
    color: #888;
    line-height: 1.5;
    margin-bottom: 8px;
    flex-shrink: 0;
  }

  .btn-list {
    flex-shrink: 0;

    .btn-row {
      display: flex;
      align-items: center;
      margin-bottom: 6px;

      &.full {
        margin-top: 2px;
      }

      .status-tag {
        font-size: 10px;
        color: #fff;
        background: #bbb;
        padding: 2px 6px;
        border-radius: 3px;
        margin-right: 8px;
        flex-shrink: 0;
        transition: background 0.2s;
        line-height: 1.4;

        &.added {
          background: #67c23a;
        }
      }

      .ctrl-btn {
        flex: 1;
        padding: 7px 10px;
        border: 1px solid #67c23a;
        color: #67c23a;
        background: #fff;
        border-radius: 4px;
        font-size: 13px;
        cursor: pointer;
        transition: all 0.2s;
        line-height: 1.2;

        &:active {
          opacity: 0.7;
          background: rgba(103, 194, 58, 0.06);
        }
      }

      .ctrl-btn-full {
        width: 100%;
        color: #666;
        border-color: #dcdcdc;
        background: #fafafa;

        &.active {
          border-color: #67c23a;
          color: #67c23a;
          background: #fff;
        }
      }
    }
  }

  /* 底部按钮：上下排列 */
  .bottom-btns {
    margin-top: auto;
    padding-top: 8px;
    border-top: 1px solid #f2f2f2;
    display: flex;
    flex-direction: column;
    gap: 6px;

    .reset-btn {
      width: 100%;
      padding: 8px 12px;
      border: 1px solid #67c23a;
      color: #67c23a;
      background: #fff;
      border-radius: 20px;
      font-size: 13px;
      cursor: pointer;
      line-height: 1.2;

      &:active {
        opacity: 0.7;
      }
    }

    .save-btn {
      width: 100%;
      padding: 9px 12px;
      background: linear-gradient(90deg, #67c23a, #5aff8e);
      color: #fff;
      border: none;
      border-radius: 20px;
      font-size: 13px;
      cursor: pointer;
      box-shadow: 0 2px 6px rgba(103, 194, 58, 0.3);
      line-height: 1.2;

      &:active {
        opacity: 0.85;
      }
    }
  }
}

/* ===== 可拖拽元素 ===== */
.draggable-item {
  position: absolute;
  cursor: move;
  border: 1px dashed transparent;
  box-sizing: border-box;
  transition: border-color 0.15s;
  touch-action: none;

  &.active {
    border-color: #67c23a;
  }

  .drag-body {
    width: 100%;
    height: 100%;
    cursor: move;
    position: relative;
  }

  /* 裁剪模式下裁剪容器，裁掉超出框的图片部分 */
  .drag-body.cropping {
    overflow: hidden;
  }

  .item-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    -webkit-user-drag: none;
    pointer-events: none;
  }

  /* 已裁剪的图片：绝对定位放大，配合位置偏移实现裁剪 */
  .item-img.cropping {
    position: absolute;
    top: 0;
    left: 0;
    max-width: none;
    max-height: none;
    object-fit: fill;
    -webkit-user-drag: none;
    pointer-events: none;
  }

  /* 裁剪模式：矩形裁剪框与蒙版 */
  .crop-shade {
    position: absolute;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2;
    pointer-events: none;
  }

  .crop-box {
    position: absolute;
    border: 1px dashed #fff;
    box-shadow: 0 0 0 1px #1989fa inset;
    z-index: 3;
    box-sizing: border-box;
  }

  .crop-handle {
    position: absolute;
    width: 14px;
    height: 14px;
    background: #1989fa;
    border: 2px solid #fff;
    border-radius: 50%;
    z-index: 4;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);

    &.c-tl {
      top: -7px;
      left: -7px;
      cursor: nwse-resize;
    }
    &.c-tr {
      top: -7px;
      right: -7px;
      cursor: nesw-resize;
    }
    &.c-bl {
      bottom: -7px;
      left: -7px;
      cursor: nesw-resize;
    }
    &.c-br {
      bottom: -7px;
      right: -7px;
      cursor: nwse-resize;
    }
  }

  .item-text {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    word-break: break-all;
    color: #222;
    line-height: 1.4;
    overflow: hidden;
    pointer-events: none;
  }

  .resize-handle {
    position: absolute;
    width: 14px;
    height: 14px;
    background: #67c23a;
    border-radius: 50%;
    border: 2px solid #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    z-index: 2;

    &.tl {
      top: -7px;
      left: -7px;
      cursor: nwse-resize;
    }
    &.tr {
      top: -7px;
      right: -7px;
      cursor: nesw-resize;
    }
    &.bl {
      bottom: -7px;
      left: -7px;
      cursor: nesw-resize;
    }
    &.br {
      bottom: -7px;
      right: -7px;
      cursor: nwse-resize;
    }
  }

  .delete-btn {
    position: absolute;
    top: -26px;
    right: -7px;
    width: 20px;
    height: 20px;
    background: #f56c6c;
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    z-index: 3;
  }

  /* 作品图片专属操作按钮：裁剪 / 旋转（右上角） */
  .image-ops {
    position: absolute;
    top: -30px;
    left: -7px;
    display: flex;
    gap: 6px;
    z-index: 3;

    .op-btn {
      padding: 4px 8px;
      border: none;
      border-radius: 4px;
      color: #fff;
      font-size: 11px;
      line-height: 1;
      cursor: pointer;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
      white-space: nowrap;

      &:active {
        opacity: 0.75;
      }
    }

    .crop-btn {
      background: #1989fa;
    }

    .done-btn {
      background: #67c23a;
    }
  }

  /* 旋转手柄：位于图片右上角外侧，按住围绕图片中心自由旋转 */
  .rotate-handle {
    position: absolute;
    top: -30px;
    right: 50%;
    width: 16px;
    height: 16px;
    background: #fff;
    border: 2px solid #67c23a;
    border-radius: 50%;
    cursor: grab;
    z-index: 4;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);

    &:active {
      cursor: grabbing;
    }
  }

  /* 手柄与图片角的连接线 */
  .rotate-handle::before {
    content: "";
    position: absolute;
    left: 50%;
    top: 100%;
    width: 2px;
    height: 16px;
    transform: translateX(-50%);
    background: #67c23a;
  }

  .font-size-controls {
    position: absolute;
    bottom: -38px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    background: rgba(0, 0, 0, 0.75);
    border-radius: 4px;
    padding: 3px 6px;
    color: #fff;
    font-size: 11px;
    white-space: nowrap;
    z-index: 3;

    button {
      width: 28px;
      height: 22px;
      background: transparent;
      border: 1px solid #fff;
      color: #fff;
      border-radius: 3px;
      margin: 0 3px;
      font-size: 11px;

      &:active {
        opacity: 0.6;
      }
    }

    span {
      margin: 0 5px;
      min-width: 32px;
      text-align: center;
    }
  }
}
</style>

<style lang="scss">
/* ===== 证书DIY横屏页面专属的全局样式（非 scoped）=====
   Toast / Popup 都渲染在 body 下，无法被组件 scoped 样式命中，故用全局样式。
   该页面整体 rotate(90deg) 横屏显示，因此提示与弹窗也要向右转 90°
   以与页面朝向一致。 */

/* ---- Toast：覆盖 Vant 默认 translate(-50%,-50%)，先居中再向右转 90° ---- */
.diy-toast-landscape {
  transform: translate(-50%, -50%) rotate(90deg) !important;
}

/* ---- 证书生成结果弹窗 ---- */
/* 弹窗外壳：全屏固定覆盖竖屏视口。生成结果是【竖向证书图片】，
   直接在竖屏视口内居中显示即可，无需再做页面那样的旋转。 */
.van-popup.diy-save-popup {
  background-color: unset;
  overflow: hidden;
  top: 0;
  bottom: auto;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  transform: none !important;
}

/* 内容区：全屏 flex 布局，竖向证书图片垂直居中。
   注意：页面通过 rotate(90deg) 呈现横屏，但弹窗显示的是已生成的
   【竖向】证书图，直接按竖屏视口居中即可，图片朝向保持竖向正确。 */
.diy-save-popup .diy-save-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 16px;
}

/* 关闭按钮：定位到视口右上角（position:fixed 相对视口，图标保持正立） */
.diy-save-popup .diy-save-close {
  position: fixed;
  top: 12px;
  right: 12px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  color: #fff;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: background 0.2s;

  &:active {
    background: rgba(255, 255, 255, 0.45);
  }

  .van-icon {
    display: block;
  }
}

.diy-save-popup .diy-save-tip {
  flex-shrink: 0;
  font-size: 14px;
  text-align: center;
  color: #fff;
  white-space: nowrap;
  margin: 0 0 14px;
}

.diy-save-popup .diy-save-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
  /* 证书图在弹窗中显示时需向左旋转 90° 才朝向正确 */
  transform: rotate(-90deg);
}
</style>